// const host = "https://api.enfirad.com/";


// const host = "http://localhost:5000/";
const host = "https://api.mizeej.app/";

export default host